import { render, staticRenderFns } from "./createMessageTemplate.vue?vue&type=template&id=0de28291&scoped=true"
import script from "./createMessageTemplate.vue?vue&type=script&lang=js"
export * from "./createMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./createMessageTemplate.vue?vue&type=style&index=0&id=0de28291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de28291",
  null
  
)

export default component.exports